import { Interval } from 'types/generated/subscriptionsApi';
import { neverop } from 'utils';

export const defaultUpsellActionsContext = {
    couponCode: undefined,
    discountPercentage: undefined,
    endDate: undefined,
    frequency: 'Yearly' as Interval,
    hasSale: false,
    hasStudioPlan: false,
    hasSamplesPlan: false,
    purchaseLink: '',
    samplesCatalog: undefined,
    selectedPlan: '',
    showFrequencySwitch: true,
    showYearly: true,
    studioCatalog: undefined,
    saleCatalog: undefined,
    yearlySaving: 0,
    getDiscountedPlan: neverop(
        'UpsellActionsProvider',
        'getDiscountedPlan',
        undefined,
    ),
    handleFrequencyChange: neverop(
        'UpsellActionsProvider',
        'handleFrequencyChange',
    ),
    handlePlanSelect: neverop('UpsellActionsProvider', 'handlePlanSelect'),
};
